import React from 'react';
import ReactDOM from 'react-dom/client';
import "./index.css"
import App from './App';
// import './../src/pages/Dashboard/dashboardTailwind.css'
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline} from '@mui/material';
import theme from './theme';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <ThemeProvider theme={theme}>
    <CssBaseline/>
    <App />
  </ThemeProvider>
  // </React.StrictMode>
);
